import React, { Component } from 'react';
import { Form, Row, Col, Button, Input, DatePicker } from 'antd';
import styles from './index.less';

const { Item } = Form;
const { RangePicker } = DatePicker;

@Form.create()
class Index extends Component {
  onSubmit = e => {
    e.preventDefault();
    const { form } = this.props;
    const { validateFields } = form;
    validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }
    });
  };

  onReset = () => {
    const { form, handleReset } = this.props;
    const { resetFields } = form;
    resetFields();

    if (handleReset) {
      handleReset();
    }
  };

  renderTitle = (formItemLayout, getFieldDecorator) => {
    return (
      <Col span={8}>
        <Item {...formItemLayout} label="文章标题">
          {getFieldDecorator('title', {
            initialValue: '',
          })(<Input placeholder="请搜索文章标题" />)}
        </Item>
      </Col>
    );
  };

  renderDate = (formItemLayout, getFieldDecorator) => {
    return (
      <Col span={8}>
        <Item label="群发时间" {...formItemLayout}>
          {getFieldDecorator(
            `range-picker`,
            {}
          )(<RangePicker format="YYYY-MM-DD" placeholder={['请选择', '请选择']} />)}
        </Item>
      </Col>
    );
  };

  renderBtn = () => {
    return (
      <Col span={8} style={{ textAlign: 'right' }}>
        <Button type="primary" htmlType="submit">
          查询
        </Button>
        <Button style={{ marginLeft: 8 }} onClick={this.onReset}>
          重置
        </Button>
      </Col>
    );
  };

  renderSearch = (formItemLayout, getFieldDecorator) => {
    return (
      <>
        <Row>
          {this.renderTitle(formItemLayout, getFieldDecorator)}
          {this.renderDate(formItemLayout, getFieldDecorator)}
          {this.renderBtn()}
        </Row>
      </>
    );
  };

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;

    const formItemLayout = {
      colon: true,
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };

    return (
      <Form className={styles.root} onSubmit={this.onSubmit}>
        {this.renderSearch(formItemLayout, getFieldDecorator)}
      </Form>
    );
  }
}

export default Index;
